import { apiService } from './api';

export interface AITutorMessage {
  role: 'user' | 'model';
  text: string;
}

export const aiApi = {
  /**
   * 请求 AI 解题辅导（无状态；前端持有完整多轮历史，每次带上）。
   * 首轮带截图 base64（不含 data: 前缀）。返回 AI 回复文本。
   */
  async tutor(
    messages: AITutorMessage[],
    imageBase64?: string,
    mimeType = 'image/png'
  ): Promise<string> {
    const res: any = await apiService.post('/ai/tutor', { messages, imageBase64, mimeType });
    return (res.data?.reply as string) || '';
  },
};
